module.exports = __webpack_public_path__ + "img/beth-macdonald-mbND4xtrlVY-unsplash.1231f937.png";